import React, { useState } from 'react';
import { motion } from 'framer-motion';

const MAX_CHARS = 300;

const CouplesMessage = ({ data, onNext }) => {
  const [message, setMessage] = useState(data.message || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onNext({ message: message.trim() });
    }
  };

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">Write from the Heart ✍️</h2>
      <p className="text-gray-500 text-sm mb-6">Express your feelings — max {MAX_CHARS} characters</p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="relative">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value.slice(0, MAX_CHARS))}
            placeholder={`Dear ${data.recipientName || 'my love'}, every moment with you is special...`}
            rows={6}
            className="w-full p-4 rounded-xl border border-gray-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-100 outline-none resize-none leading-relaxed text-gray-700"
          />
          <div className="absolute bottom-3 right-3">
            <span className={`text-xs font-bold ${
              message.length > MAX_CHARS * 0.9 ? 'text-red-500' :
              message.length > MAX_CHARS * 0.7 ? 'text-amber-500' : 'text-gray-400'
            }`}>
              {message.length}/{MAX_CHARS}
            </span>
          </div>
        </div>

        {message && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-gradient-to-b from-purple-50 to-white rounded-2xl p-5 border border-purple-100"
          >
            <p className="text-xs text-purple-400 font-semibold uppercase tracking-wider mb-2">Preview</p>
            <p className="text-gray-700 italic leading-relaxed">"{message}"</p>
          </motion.div>
        )}

        <button type="submit" disabled={!message.trim()}
          className="w-full bg-gradient-to-r from-purple-500 to-violet-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-purple-200 disabled:opacity-50">
          Continue →
        </button>
      </form>
    </motion.div>
  );
};

export default CouplesMessage;